import React, { FC } from 'react';
import { useApplication } from '../../../../context/ApplicationContext';
import { get } from 'lodash';

import Schema from '../../../../lib/paths/zuwendungsantrag_FULL_Paths.json';
import { Breadcrumbs, Typography } from '@mui/material';
import { enumT } from '../../../../utils/helper';
const P = Schema.attributes;

const BreadcrumbZuwendungsantrag: FC<{}> = () => {
	const { application } = useApplication();

	return (
		<>
			<Breadcrumbs separator="›" aria-label="breadcrumb" sx={{ maxWidth: '81.875rem', marginTop: '0.75rem', marginBottom: '2rem' }}>
				<Typography color="text.secondary">Mein Bereich</Typography>
				<Typography color="text.secondary">Meine Anträge</Typography>
				<Typography color="text.secondary">{enumT(get(application, P.Allgemein_Typ.path, ''))}</Typography>
				<Typography color="primary">{get(application, P.Allgemein_Projekttitel.path, '*')}</Typography>
			</Breadcrumbs>
		</>
	);
};

export default BreadcrumbZuwendungsantrag;
